// extracted by mini-css-extract-plugin
module.exports = {"icon":"Payment_icon__3qnEZ","content":"Payment_content__NvTVR","container":"Payment_container__2A66d"};